import React, { useEffect } from "react";
import ChatBoard from "./pages/ChatBoard";
import { v4 as uuidv4 } from "uuid";
function App() {
  const getSessionId = () => {
    let sessionId = localStorage.getItem("chatSessionId");
    if (!sessionId) {
      sessionId = uuidv4();
      localStorage.setItem("chatSessionId", sessionId);
    }
    return sessionId;
  };

  useEffect(()=>{
    getSessionId()
  },[])
  return (
    <div className="bg-gray-100 min-h-screen">
      <ChatBoard />
    </div>
  );
}

export default App;
